import { t } from '../lib/i18n.js';

// Job-Fortschritt: pollt den Status und aktualisiert Balken, Log und Status. Adressen
// kommen aus dem Template (data-status-url, data-login-url) und der Antwort (run_url).
// Ein wartender Job (queued, Queue) zählt als aktiv; startet er, lädt die Seite einmal
// neu - Warteschlange und Abbrechen verschwinden, der Fortschritt erscheint.
export default function jobProgress() {
  const root = document.querySelector('[data-job]');
  if (!root) return;

  const bar = root.querySelector('[data-bar]');
  const label = root.querySelector('[data-progress-label]');
  const state = root.querySelector('[data-state]');
  const log = root.querySelector('[data-log]');
  const done = root.querySelector('[data-done]');
  const runLink = root.querySelector('[data-run-link]');
  // Text und Farbe je Status aus Labels (job_status), mitgegeben als data-states.
  const states = JSON.parse(root.dataset.states || '{}');

  let delay = 1200;
  const ACTIVE = ['queued', 'starting', 'running'];

  // "3 von 10 Abfragen · 30 %". Die Einheit (unit) schickt der Server schon in
  // der Sprache der Seite mit (JobRunner::progress); ohne sie zählen Abfragen.
  function progressText(progress) {
    const params = { done: progress.done, total: progress.expected, percent: progress.percent };
    return progress.unit
      ? t('{done} von {total} {unit} · {percent} %', Object.assign({ unit: progress.unit }, params))
      : t('{done} von {total} Abfragen · {percent} %', params);
  }

  async function poll() {
    try {
      const res = await fetch(root.dataset.statusUrl, { headers: { 'Accept': 'application/json' } });
      // Sitzung abgelaufen: zur Anmeldung, danach zurück auf diese Seite.
      if (res.status === 401) {
        window.location.href = root.dataset.loginUrl + '?next=' + encodeURIComponent(window.location.pathname);
        return;
      }
      if (!res.ok) throw new Error('Status ' + res.status);
      const data = await res.json();

      if (root.dataset.initialStatus === 'queued' && data.status !== 'queued') {
        window.location.reload();
        return;
      }

      if (bar && data.progress) {
        bar.value = data.progress.percent;
        bar.classList.toggle('is-done', data.status === 'done');
        bar.classList.toggle('is-failed', data.status === 'failed');
      }
      if (label && data.progress) {
        label.textContent = data.progress.expected > 0
          ? progressText(data.progress)
          : (data.status === 'running' ? t('läuft …') : '');
      }
      if (log && typeof data.log === 'string' && data.log !== log.textContent) {
        const atBottom = log.scrollHeight - log.scrollTop - log.clientHeight < 40;
        log.textContent = data.log;
        if (atBottom) log.scrollTop = log.scrollHeight;
      }

      if (ACTIVE.indexOf(data.status) !== -1) {
        // Sanft langsamer werden: lange Läufe erzeugen sonst unnötig viele Requests.
        delay = Math.min(delay * 1.15, 5000);
        setTimeout(poll, delay);
        return;
      }

      if (state) {
        const end = states[data.status] || { label: data.status, tone: 'info' };
        state.className = 'tag tag-' + end.tone;
        state.textContent = end.label;
      }
      if (done) done.hidden = false;
      if (runLink && data.run_url) {
        runLink.hidden = false;
        runLink.href = data.run_url;
      }
      const spinner = root.querySelector('[data-spinner]');
      if (spinner) spinner.remove();
      const hint = document.querySelector('[data-running-hint]');
      if (hint) hint.remove();

      // Die Bilanz rendert der Server. Wurde die Seite noch während des Laufs
      // geladen, ist sie leer - dann genau einmal neu laden. Die neu geladene
      // Seite kennt den Endstatus bereits und lädt nicht erneut.
      const summary = root.querySelector('[data-summary]');
      const wasActive = ACTIVE.indexOf(root.dataset.initialStatus) !== -1;
      // Bilanz gibt es für Läufe (Abfragen) und für Jobs mit eigenem Ergebnis (Domain-Tags).
      if (summary && ((data.result && data.result.total > 0) || data.summary)) {
        if (wasActive) {
          window.location.reload();
          return;
        }
        summary.hidden = false;
      }
    } catch (e) {
      setTimeout(poll, 4000);
    }
  }

  poll();
}
